import { View } from './view'

export const FullLogo = View
